import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnObjects: true,
    fallbackLng: "en",
    defaultLanguage: "en",
    debug: true,
    ns: ["translation"],
    defaultNS: "translation",
    backend: {
      // Cache-bust por arranque para que usuarios vean strings nuevos sin
      // tener que hacer Ctrl+F5 (Vite no inyecta hash en /public).
      loadPath: `/admin/Locales/{{lng}}.json?v=${Date.now()}`,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
